import Backbone from 'backbone'
import Request from '../helpers/request'

const ClassModel = Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        selected: null,
    },
    update(name) {
        return Request({
            url: `/api/school/class/${this.get('id')}`,
            method: 'PUT',
            data: {
                name: name,
            },
        })
            .then((response) => {
                this.set('name', name)
            })
    },
    create(name) {
        return Request({
            url: '/api/school/class',
            method: 'POST',
            data: {
                name: name,
            },
        })
    },
    delete() {
        return Request({
            url: `/api/school/class/${this.get('id')}`,
            method: 'DELETE',
        })
            .then((response) => {
                this.trigger('destroy', this)
            })
    },
})

export default ClassModel